<script setup>
import {Redirect} from "@shopify/app-bridge/actions";
import useShopify from "@/composables/shopify/useShopify";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const {app, baseUrl} = useShopify();

const redirect = Redirect.create(app);

const shop = new URLSearchParams(location.search).get("shop");

const doShopifyOauth = () => {
  redirect.dispatch(Redirect.Action.REMOTE, `${baseUrl}/shopify/oauth?shop=${shop}`);
};

</script>

<template>
  <div class="tw-flex tw-flex-col tw-justify-center tw-gap-8 tw-items-center tw-min-h-full">
    <h1 class="tw-text-3xl tw-font-bold">
      Welcome to Hike
    </h1>

    <div class="tw-flex tw-gap-4 tw-items-center">
      <svg-vue
        icon="logos/shopify"
        class="tw-w-32"
      />
      <svg-vue
        icon="icons/arrow-right"
        class="tw-w-8 tw-h-8"
      />
      <svg-vue
        icon="logos/hike"
        class="tw-w-32"
      />
    </div>

    <p>To get started we need to link your Shopify account to the Hike platform</p>

    <DefaultButton
      class="tw-border tw-rounded tw-px-2 tw-py-1 tw-m-1"
      @click.prevent="doShopifyOauth"
    >
      Connect Shopify to Hike
    </DefaultButton>
  </div>
</template>